export var AIPageFileChangeType;
(function (AIPageFileChangeType) {
    AIPageFileChangeType["Added"] = "added";
    AIPageFileChangeType["Deleted"] = "deleted";
    AIPageFileChangeType["Modified"] = "modified";
    AIPageFileChangeType["Renamed"] = "renamed";
})(AIPageFileChangeType || (AIPageFileChangeType = {}));
export var AIPageFileNodeType;
(function (AIPageFileNodeType) {
    AIPageFileNodeType["File"] = "file";
    AIPageFileNodeType["Directory"] = "directory";
})(AIPageFileNodeType || (AIPageFileNodeType = {}));
function createFileMap(files, map = new Map()) {
    files.forEach((file) => {
        map.set(file.path, file);
        if (file.type === AIPageFileNodeType.Directory && file.children) {
            createFileMap(file.children, map);
        }
    });
    return map;
}
export function diffAIPageFileTrees(originFiles, compareFiles) {
    const changes = [];
    const originMap = createFileMap(originFiles);
    const compareMap = createFileMap(compareFiles);
    compareMap.forEach((compareFile, path) => {
        if (compareFile.type !== AIPageFileNodeType.File)
            return;
        const originFile = originMap.get(path);
        if (!originFile) {
            changes.push({
                path,
                name: compareFile.name,
                type: AIPageFileChangeType.Added,
                modifiedContent: compareFile.content || '',
                contentLoaded: true,
            });
        }
        else if (originFile.oid !== compareFile.oid) {
            changes.push({
                path,
                name: compareFile.name,
                type: AIPageFileChangeType.Modified,
                originalContent: originFile.content || '',
                modifiedContent: compareFile.content || '',
                contentLoaded: true,
            });
        }
    });
    originMap.forEach((originFile, path) => {
        if (originFile.type !== AIPageFileNodeType.File || compareMap.has(path))
            return;
        changes.push({
            path,
            name: originFile.name,
            type: AIPageFileChangeType.Deleted,
            originalContent: originFile.content || '',
            contentLoaded: true,
        });
    });
    return changes;
}
export const legacyAIPageDiffDataSource = {
    async loadChanges(originCommitId, compareCommitId) {
        const { getAIPageCodeByCommitId } = await import('@/modules/ai-page/utils/code');
        const result = await getAIPageCodeByCommitId(originCommitId, compareCommitId);
        const originFiles = result.originFiles ?? [];
        const compareFiles = result.compareFiles ?? [];
        return {
            changes: diffAIPageFileTrees(originFiles, compareFiles),
            originFiles,
            compareFiles,
        };
    },
    async loadContent(change) {
        return {
            originalContent: change.originalContent,
            modifiedContent: change.modifiedContent,
        };
    },
};
export function createUnavailableAIPageDiffDataSource(message) {
    const fail = async () => {
        throw new Error(message);
    };
    return {
        loadChanges: fail,
        loadContent: fail,
    };
}
